// Copyright (c) 2022 by Move Closer

import { FormFieldsetData } from '../../../shared/contracts/forms'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface GuestDetailsFormData {
  /**
   * Guest's email.
   */
  email: string

  /**
   * Guest's first name.
   */
  firstName: string

  /**
   * Guest's last name.
   */
  lastName: string

  /**
   * Determines guest's password in case he wants to create an acc.
   */
  password?: string

  /**
   * Repeated password.
   */
  passwordConfirmation?: string

  /**
   * Guest's phone number.
   */
  phone: string

  /**
   * Determines whether user wants to subscribe to news.
   */
  subscribeToNews: boolean

  /**
   * Determines vatId
   */
  vatId?: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface GuestDetailsFormFieldsetProps extends FormFieldsetData<GuestDetailsFormData> {
  /**
   * Errors map for fields.
   */
  _errors: Record<string, string[]> | null
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum SSOContextMode {
  Company = 'company',
  Guest = 'guest'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface GuestDetailsFormFieldsetConfig {
  hasSSOContextSwitcher: boolean
}
